import Chats from './container';

export default Chats;



// WEBPACK FOOTER //
// ./src/components/Chats/index.js